var React = require('react');

function IconTestedBenefit (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Paths"},[React.createElement("path",{"id":"Vector","d":"M5 2.40005C6.2 1.80005 6.6 1.20005 7 0.800049C7.4 1.20005 7.8 1.80005 9 2.40005C10.2 3.00005 10.8 2.80005 11.8 3.20005C12.8 3.60005 13 4.20005 13 5.40005C13 6.60005 12.8 9.60005 12.4 10.8C12 12 9.4 14.4 7 15.2C4.6 14.4 2 12 1.6 10.8C1.2 9.60005 1 6.60005 1 5.40005C1 4.20005 1.2 3.60005 2.2 3.20005C3.2 2.80005 3.8 3.00005 5 2.40005Z","stroke":"#A1AAC5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M5 8.25549L6.35207 9.5L9 6.5","stroke":"#A1AAC5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

IconTestedBenefit.defaultProps = {"width":"14","height":"16","viewBox":"0 0 14 16","fill":"none"};

module.exports = IconTestedBenefit;

IconTestedBenefit.default = IconTestedBenefit;
